var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIllustrationPlus = function SvgIllustrationPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1835_5441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 45.4286C35.8345 45.4286 45.4284 35.8347 45.4284 24C45.4284 12.1653 35.8345 2.57141 23.9999 2.57141C12.1652 2.57141 2.57129 12.1653 2.57129 24C2.57129 35.8347 12.1652 45.4286 23.9999 45.4286Z",
    stroke: "#9F81DE",
    strokeWidth: 3.42857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 15.4286V32.5714",
    stroke: "#E081B5",
    strokeWidth: 3.42857,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5716 24H15.4287",
    stroke: "#E081B5",
    strokeWidth: 3.42857,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1835_5441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};

export { SvgIllustrationPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4MzVfNTQ0MSkiPgo8cGF0aCBkPSJNMjMuOTk5OSA0NS40Mjg2QzM1LjgzNDUgNDUuNDI4NiA0NS40Mjg0IDM1LjgzNDcgNDUuNDI4NCAyNEM0NS40Mjg0IDEyLjE2NTMgMzUuODM0NSAyLjU3MTQxIDIzLjk5OTkgMi41NzE0MUMxMi4xNjUyIDIuNTcxNDEgMi41NzEyOSAxMi4xNjUzIDIuNTcxMjkgMjRDMi41NzEyOSAzNS44MzQ3IDEyLjE2NTIgNDUuNDI4NiAyMy45OTk5IDQ1LjQyODZaIiBzdHJva2U9IiM5RjgxREUiIHN0cm9rZS13aWR0aD0iMy40Mjg1NyIvPgo8cGF0aCBkPSJNMjQgMTUuNDI4NlYzMi41NzE0IiBzdHJva2U9IiNFMDgxQjUiIHN0cm9rZS13aWR0aD0iMy40Mjg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMi41NzE2IDI0SDE1LjQyODciIHN0cm9rZT0iI0UwODFCNSIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODM1XzU0NDEiPgo8cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";